<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-responsive class="overflow-y-auto" :max-height="$store.state.maxHeight">
  <v-container>
    <v-row class="fill-height" align="center" justify="center">
      <template v-for="(item, i) in items">
        <v-col
          :key="i"
          cols="12"
          md="6"
          sm="12"
          dark
        >
          <v-hover v-slot:default="{ hover }" dark>
            <v-card
              class="mx-auto"
              max-width="600"
              style="width:90vw;"
              dark
            >
              <v-img
                :aspect-ratio="12/8"
                :contain="true"
                :src="item.img"
              >
                <v-expand-transition>
                  <div
                    v-if="hover && !$vuetify.breakpoint.xs"
                    class="d-flex transition-fast-in-fast-out orange darken-2 v-card--reveal display-3 white--text"
                    style="height: 100%;"
                  >
                    {{ item.category.replace("—","") }}
                  </div>
                  <div
                    v-if="hover && $vuetify.breakpoint.xs"
                    class="d-flex transition-fast-in-fast-out orange darken-2 v-card--reveal display-3 white--text"
                    style="height: 100%;font-size:2em !important;"
                  >
                    {{ item.category.replace("—","") }}
                  </div>
                </v-expand-transition>
              </v-img>
              <v-card-text
                class="pt-6"
                style="position: relative;padding-left:0px;padding-right:0px;"
              >
                <v-btn
                  absolute
                  color="orange"
                  class="white--text"
                  fab
                  large
                  right
                  top
                >
                  <v-icon>mdi-import</v-icon>
                </v-btn>
                <div class="font-weight-light grey--text title mb-2">{{ item.name }}</div>
                <h3 class="display-1 font-weight-light orange--text mb-2">{{ item.category }}</h3>
                <div class="font-weight-light title mb-2">
                  {{ item.desc }}
                </div>
                <v-bottom-navigation
                >
                  <v-btn
                    v-for="n in 6"
                    :key="n"
                    min-width="5vw"
                    style="padding-right:0px;padding-left:0px;"
                    >
                    <span>{{ item.compose[n-1] }}</span>
                    <v-icon  color="red">{{ item.icons[n-1] }}</v-icon>
                  </v-btn>
                </v-bottom-navigation>
              </v-card-text>
            </v-card>
          </v-hover>
        </v-col>
      </template>
    </v-row>
    <v-divider></v-divider>
    <v-row>
      <v-col>
        <v-row
        >
          <v-card
            v-for="(item,index) in taMsg"
            :key="index"
            class="ma-3 pa-6"
            max-width="500"
          >
            <v-img
              :src="item.img"
              :aspect-ratio="16/12"
              contain
            >

            </v-img>
            <v-card-title>
              <div class="display-1 mb-2">{{ item.name }}</div>
              <span>--易途助教</span>
              <div class="title font-weight-regular grey--text">{{ item.desc }}</div>
            </v-card-title>
          </v-card>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</v-responsive>
</template>
<style>
  .v-card--reveal {
    align-items: center;
    bottom: 0;
    justify-content: center;
    opacity: .5;
    position: absolute;
    width: 100%;
  }
</style>
<script>
  export default {
    data () {
      return {
        clientWidth:document.documentElement.clientWidth,
        taMsg:[
          {img:'../../../static/teacher/db.jpg',desc:'一是选择 二是相信 三是拼 四就对了',name:'大白'},
          {img:'../../../static/teacher/gs.jpg',desc:'虽然后面的旅程可能还有很久，未来我也不能估测。但我还有能力正在依着那份喜爱努力追寻着。爬山虽苦，但山顶的景色能让我忘却所有的苦和累！我已出发，等你。',name:'刘国胜'},
          // {img:'../../../static/teacher/hqq.jpg',desc:'奋斗令我们的生活充满生机，责任让我们的生命充满意义，常遇困境说明你在进步，常有压力,说明你有目标。',name:'韩倩倩'},
           {img:'../../../static/teacher/xd.jpg',desc:'追光的人，终会光芒万丈',name:'李旭东'},
        {img:'../../../static/teacher/lmq.jpg',desc:'道阻且长，行则将至',name:'李梦琪'},
            {img:'../../../static/teacher/zxy.jpg',desc:'勤思多练，学到真本事.',name:'赵新月'},  
            {img:'../../../static/teacher/rjy.png',desc:'人生就像 Java 继承，你无法选择父类，但可以重写出自己的方法。',name:'任璟怡'},  

          ],
        items: [
          {
            name: '汪老师',
            category: "—易途COREJAVA讲师",
            desc: '人气颇高的美女讲师，授课严谨细致、脉络清晰，讲解声情并茂，善于拓展延伸，亲和力强，对待教学认真负责，要求严格，循循善诱，平易近人，不厌其烦，细心讲解，经验丰富，深入浅出，逻辑性强，善于总结归纳重点和难点。负责Java核心技术的教学，是无数易途学员的启蒙老师。',
            img: '../../../static/teacher/wl.png',
            compose:['JVM构成','核心语法','数据类型','运算符','面向对象','设计模式'],
            icons: ['mdi-home-search-outline','mdi-tag-heart','mdi-format-list-bulleted-type','mdi-plus','mdi-account-supervisor','mdi-grease-pencil'],
          },
          {
            name: '薄老师',
            category: '—易途数据库讲师',
            desc: '四年开发经验，曾在胜利油田项目中负责数据库迁移，并在中国移动旗下咪咕阅读参与数据库方案设计，数据实时推送，还在建筑，金融，电商，智能警务等多个行业积累了Oracle丰富的实战经验，并将整个课程都与现实工作紧密结合起来，负责Oracle数据库教学。',
            img: '../../../static/teacher/bqp.png',
            compose:['Oracle','MySQL','XML','JDBC','DBCP','连接池实现'],
            icons: ['mdi-moon-new','mdi-alpha-m-box-outline','mdi-close-thick','mdi-lan-connect','mdi-database-import','mdi-database'],
          },
          {
            name: '张老师',
            category: '—前端全栈讲师',
            desc: '六年开发经验，精通H5/CSS3/ES6/Vue/Vuex等WEB前端技术，精通ICBCCTP等大型框架，曾任职上海工商银行科技部技术总监，后转向JAVA教学，兼任多家网络技术公司研发顾问。授课有着迷人的魅力，在讲解知识中，总会有出其不意的精彩亮点，深受广大学员的喜爱。 负责J2EE核心技术的教学',
            img: '../../../static/teacher/zwc.png',
            compose:['Vue','JQuery','HTML','Javascript','AJAX','JSP'],
            icons: ['mdi-vuejs','mdi-jquery','mdi-language-html5','mdi-language-javascript','mdi-elevator-up','mdi-alpha-j'],
          },
          {
            name: '周老师',
            category: '—易途持久层框架全栈讲师',
            desc: '八年开发经验，五年教学经验，精通UNIX/LINUX，擅长持久层深挖掘，华东地区著名MYBITIS课程专家，曾任多个企业项目组技术总监，后于2010年专注于JAVA教学。专业功底深厚，讲解精辟透彻，善于启迪学生思路，剖析底层框架架构，思路非常清晰。负责持久层框架以及表现层框架技术的教学',
            img: '../../../static/teacher/zk.png',
            compose:['Spring','MyBatis','Hibernate','JPA','持久层框架','框架原理'],
            icons: ['mdi-leaf','mdi-alpha-m-box-outline','mdi-alpha-h-box-outline','mdi-alpha-j-box-outline','mdi-content-duplicate','mdi-electron-framework'],
          },
          {
            name: '卢老师',
            category: '—易途Spring框架全栈讲师',
            desc: '企业级培训专家，曾任职中国联通系统集成分公司，负责内部商城的开发和维护工作。精通系统中设计建模，部署运行，监管和分析管理，精通Spring框架底层逻辑，精通SpringBoot、SpringCloud微服务和分布式平台技术。',
            img: '../../../static/teacher/lxl.png',
            compose:['Spring Cloud','SpringBoot','Webservice','Quartz','微服务','项目整合'],
            icons: ['mdi-leaf','mdi-code-string','mdi-recycle-variant','mdi-clock-in','mdi-weather-cloudy','mdi-arrange-bring-forward'],
          },
        ],
        length: 3,
        window: 0,
        showArrows: false,
        vertical: false,
        reverse: false,
        autorun: false,
      }
    },
    created () {

      setInterval(() => {
        if (!this.autorun) return
        if (++this.window >= this.length) this.window = 0
      }, 2000)
    },
  }
</script>



// WEBPACK FOOTER //
// src/page/team/teacher-team.vue